import availableTimes from '@atlassian/jira-common-constants/src/datetimepicker-available-times';
import { INVALID_DATE, EMPTY_TIME } from '../../../../../../../../common/ui/constants.tsx';
import { isEmpty, isInvalidFormat } from '../../../../../../../../common/utils/time/index.tsx';

export const onValidate = (end: string) => {
	if (isEmpty(end)) {
		return EMPTY_TIME;
	}

	if (isInvalidFormat(end)) {
		return INVALID_DATE;
	}

	return undefined;
};

export const getAvailableTimes = (): string[] => {
	const times = [...availableTimes];
	/**
        Remove 0:00 from the begining and
        add 24:00 at the last
     */
	times.shift();
	times.push('24:00');

	return times;
};
